module.exports = __webpack_public_path__ + "media/images/partners/6-c788a4a7a1689b87cac007f4f3e061c5.png";